import crud from "@/store/core/crud";
import action from "@/store/core/action";

import {
  CREATE_PLANNED_PAYMENT,
  CREATE_PLANNED_PAYMENT_FAIL,
  CREATE_PLANNED_PAYMENT_SUCCESS,
  DELETE_PLANNED_PAYMENT,
  DELETE_PLANNED_PAYMENT_FAIL,
  DELETE_PLANNED_PAYMENT_SUCCESS,
  GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS,
  GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS_FAIL,
  GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS_SUCCESS,
  GET_PAYMENTS_PLANNED_PAGINATION,
  GET_PAYMENTS_PLANNED_PAGINATION_FAIL,
  GET_PAYMENTS_PLANNED_PAGINATION_SUCCESS,
  UPDATE_PLANNED_PAYMENT,
  UPDATE_PLANNED_PAYMENT_FAIL,
  UPDATE_PLANNED_PAYMENT_SUCCESS
} from "./actions";
import ApiService from "../../services/api";

const crudProcessed = crud.process({
  getPaginationRequest: {
    action: GET_PAYMENTS_PLANNED_PAGINATION,
    endPoint: "pay/v1/payments",
    mutationFail: GET_PAYMENTS_PLANNED_PAGINATION_FAIL,
    mutationSuccess: GET_PAYMENTS_PLANNED_PAGINATION_SUCCESS
  },
  creationRequest: {
    action: CREATE_PLANNED_PAYMENT,
    endPoint: "pay/v1/payments/manual",
    mutationFail: CREATE_PLANNED_PAYMENT_FAIL,
    mutationSuccess: CREATE_PLANNED_PAYMENT_SUCCESS
  },
  deletionRequest: {
    action: DELETE_PLANNED_PAYMENT,
    endPoint: "pay/v1/payments",
    mutationFail: DELETE_PLANNED_PAYMENT_FAIL,
    mutationSuccess: DELETE_PLANNED_PAYMENT_SUCCESS
  }
});

const actionsProcessed = action.processMultiple([
  {
    method: "post",
    name: "updatePlannedPaymentRequest",
    action: UPDATE_PLANNED_PAYMENT,
    endPoint: "pay/v1/payments/{payment_id}/replace",
    mutations: {
      fail: UPDATE_PLANNED_PAYMENT_FAIL,
      success: UPDATE_PLANNED_PAYMENT_SUCCESS
    }
  }
]);

const getters = {};

const state = {
  ...crudProcessed.state,
  ...actionsProcessed.state
};

const actions = {
  ...crudProcessed.actions,
  ...actionsProcessed.actions,
  [GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS](context) {
    return new Promise((resolve) => {
      ApiService.get("pay/v1/payment-configurations/actives")
        .then((response) => {
          context.commit(
            GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS_SUCCESS,
            response.data.data
          );
          resolve(response.data.data);
        })
        .catch(({ response }) => {
          context.commit(
            GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS_FAIL,
            response.data
          );
        });
    });
  }
};

const mutations = {
  ...crudProcessed.mutations,
  ...actionsProcessed.mutations,
  [GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS_SUCCESS]() {},
  [GET_HAS_ACTIVE_PAYMENT_AUTOMATION_CONFIGURATIONS_FAIL]() {}
};

export default {
  state,
  actions,
  mutations,
  getters
};
